<template>
  <div class="d-flex justify-content-between py-2">
    <b-button
      @click="changeToWeek(selectedWeekIndex - 1)"
      variant="link"
      class="align-self-center"
      :disabled="participantIsDraft || selectedWeekIndex <= 1"
    >
      <i class="fa fa-chevron-left mr-2"></i>
      <span>{{ $t('view_past_week') }}</span>
    </b-button>

    <b-dropdown
      variant="link"
      class="weeks-dropdown align-self-center"
      no-caret
      @show="isWeeksDropdownShown = true"
      @hide="isWeeksDropdownShown = false"
      :disabled="participantIsDraft || weeksData.length <= 0"
    >
      <template #button-content>
        {{ $t('select_a_week') }}
        <i v-if="isWeeksDropdownShown" class="fa fa-chevron-up"></i>
        <i v-if="!isWeeksDropdownShown" class="fa fa-chevron-down"></i>
      </template>

      <div v-for="(week, index) in weeksData" :key="index">
        <b-dropdown-item
          v-if="week.numWeek > 0 && week.numWeek < weeksData.length"
          @click="changeToWeek(week.numWeek)"
          >{{ $t('week') }} {{ week.numWeek }}
        </b-dropdown-item>
      </div>
    </b-dropdown>

    <b-button
      @click="changeToWeek(selectedWeekIndex + 1)"
      variant="link"
      class="align-self-center"
      :disabled="participantIsDraft || selectedWeekIndex > weeksData.length - 2"
    >
      <span>{{ $t('view_next_week') }}</span>
      <i class="fa fa-chevron-right ml-2" />
    </b-button>
  </div>
</template>

<script>
export default {
  name: 'ParticipantDetailStudyScheduleWeeksNav',
  props: ['weeks', 'selectedWeekIndex', 'participantIsDraft'],
  data() {
    return {
      isWeeksDropdownShown: false,
    };
  },
  computed: {
    weeksData() {
      return this.weeks
        .map((week) => ({ dateStart: week.dateStart, numWeek: week.numWeek }))
        .reverse();
    },
  },
  methods: {
    changeToWeek(numWeekIndex) {
      this.$emit('selectWeek', numWeekIndex);
    },
  },
};
</script>

<style scoped lang="scss">
/* remove all these classes after styling code refactor */
.btn-link {
  font-size: 1rem;

  &:active,
  &:focus {
    box-shadow: none !important;
  }
}

::v-deep {
  .btn.dropdown-toggle {
    font-size: 1rem !important;
    &::after {
      border: none !important;
    }

    &:active,
    &:focus {
      box-shadow: none !important;
    }
  }

  .dropdown-menu {
    max-height: 175px;
    overflow-y: auto;
  }
}

.weeks-dropdown {
  box-shadow: none !important;
}

/* Calendar curved icon */
$icon-cal-svg-base64-url: 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjEiIGhlaWdodD0iMjIiIHZpZXdCb3g9IjAgMCAyMSAyMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0wLjc1IDExLjc3NEMwLjc1IDQuODE4IDMuMDY5IDIuNSAxMC4wMjQgMi41QzE2Ljk4IDIuNSAxOS4yOTkgNC44MTggMTkuMjk5IDExLjc3NEMxOS4yOTkgMTguNzMgMTYuOTggMjEuMDQ4IDEwLjAyNCAyMS4wNDhDMy4wNjkgMjEuMDQ4IDAuNzUgMTguNzMgMC43NSAxMS43NzRaIiBzdHJva2U9IiMwNDZEQjMiIHN0cm9rZS13aWR0aD0iMS41IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPHBhdGggZD0iTTEuMDIzNDQgOC4zMjAzMUgxOS4wMzE0IiBzdHJva2U9IiMwNDZEQjMiIHN0cm9rZS13aWR0aD0iMS41IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPHBhdGggZD0iTTE0LjQyNTIgMTIuMjU3OEgxNC40MzQyIiBzdHJva2U9IiMwNDZEQjMiIHN0cm9rZS13aWR0aD0iMS41IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPHBhdGggZD0iTTEwLjAyNjcgMTIuMjU3OEgxMC4wMzU3IiBzdHJva2U9IiMwNDZEQjMiIHN0cm9rZS13aWR0aD0iMS41IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPHBhdGggZD0iTTUuNjIwNSAxMi4yNTc4SDUuNjI5NSIgc3Ryb2tlPSIjMDQ2REIzIiBzdHJva2Utd2lkdGg9IjEuNSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CjxwYXRoIGQ9Ik0xNC40MjUyIDE2LjEwOTRIMTQuNDM0MiIgc3Ryb2tlPSIjMDQ2REIzIiBzdHJva2Utd2lkdGg9IjEuNSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CjxwYXRoIGQ9Ik0xMC4wMjY3IDE2LjEwOTRIMTAuMDM1NyIgc3Ryb2tlPSIjMDQ2REIzIiBzdHJva2Utd2lkdGg9IjEuNSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CjxwYXRoIGQ9Ik01LjYyMDUgMTYuMTA5NEg1LjYyOTUiIHN0cm9rZT0iIzA0NkRCMyIgc3Ryb2tlLXdpZHRoPSIxLjUiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8cGF0aCBkPSJNMTQuMDMxMiAxLjA0Njg4VjQuMzA4ODgiIHN0cm9rZT0iIzA0NkRCMyIgc3Ryb2tlLXdpZHRoPSIxLjUiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8cGF0aCBkPSJNNi4wMjM0NCAxLjA0Njg4VjQuMzA4ODgiIHN0cm9rZT0iIzA0NkRCMyIgc3Ryb2tlLXdpZHRoPSIxLjUiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8L3N2Zz4=';
$icon-cal-svg-base64-url-hover: 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjEiIGhlaWdodD0iMjIiIHZpZXdCb3g9IjAgMCAyMSAyMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0wLjc1IDExLjc3NEMwLjc1IDQuODE4IDMuMDY5IDIuNSAxMC4wMjQgMi41QzE2Ljk4IDIuNSAxOS4yOTkgNC44MTggMTkuMjk5IDExLjc3NEMxOS4yOTkgMTguNzMgMTYuOTggMjEuMDQ4IDEwLjAyNCAyMS4wNDhDMy4wNjkgMjEuMDQ4IDAuNzUgMTguNzMgMC43NSAxMS43NzRaIiBzdHJva2U9IiMwMjNmNjgiIHN0cm9rZS13aWR0aD0iMS41IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPHBhdGggZD0iTTEuMDIzNDQgOC4zMjAzMUgxOS4wMzE0IiBzdHJva2U9IiMwMjNmNjgiIHN0cm9rZS13aWR0aD0iMS41IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPHBhdGggZD0iTTE0LjQyNTIgMTIuMjU3OEgxNC40MzQyIiBzdHJva2U9IiMwMjNmNjgiIHN0cm9rZS13aWR0aD0iMS41IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPHBhdGggZD0iTTEwLjAyNjcgMTIuMjU3OEgxMC4wMzU3IiBzdHJva2U9IiMwMjNmNjgiIHN0cm9rZS13aWR0aD0iMS41IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPHBhdGggZD0iTTUuNjIwNSAxMi4yNTc4SDUuNjI5NSIgc3Ryb2tlPSIjMDIzZjY4IiBzdHJva2Utd2lkdGg9IjEuNSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CjxwYXRoIGQ9Ik0xNC40MjUyIDE2LjEwOTRIMTQuNDM0MiIgc3Ryb2tlPSIjMDIzZjY4IiBzdHJva2Utd2lkdGg9IjEuNSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CjxwYXRoIGQ9Ik0xMC4wMjY3IDE2LjEwOTRIMTAuMDM1NyIgc3Ryb2tlPSIjMDIzZjY4IiBzdHJva2Utd2lkdGg9IjEuNSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CjxwYXRoIGQ9Ik01LjYyMDUgMTYuMTA5NEg1LjYyOTUiIHN0cm9rZT0iIzAyM2Y2OCIgc3Ryb2tlLXdpZHRoPSIxLjUiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8cGF0aCBkPSJNMTQuMDMxMiAxLjA0Njg4VjQuMzA4ODgiIHN0cm9rZT0iIzAyM2Y2OCIgc3Ryb2tlLXdpZHRoPSIxLjUiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8cGF0aCBkPSJNNi4wMjM0NCAxLjA0Njg4VjQuMzA4ODgiIHN0cm9rZT0iIzAyM2Y2OCIgc3Ryb2tlLXdpZHRoPSIxLjUiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8L3N2Zz4K';

%icon-cal-bg {
  padding-left: 30px;
  background-repeat: no-repeat;
  background-position-x: left;
  background-position-y: center;
}

::v-deep {
  .weeks-dropdown > .btn.dropdown-toggle {
    background-image: url($icon-cal-svg-base64-url);
    @extend %icon-cal-bg;

    &:hover {
      background-image: url($icon-cal-svg-base64-url-hover);
      @extend %icon-cal-bg;
    }
  }
}
</style>
